var _desc, _defs, _use, _use2, _use3, _use4, _use5, _use6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMacbookBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "805px",
    height: "21px",
    viewBox: "0 0 805 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "107.956459%",
    y2: "99.2466518%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F4F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECBE4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "3.061617e-15%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8BFD5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F9",
    stopOpacity: 0.5,
    offset: "1.03728612%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4F1",
    stopOpacity: 0.5,
    offset: "1.98047158%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDCED",
    stopOpacity: 0.5,
    offset: "2.91709686%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F2F8",
    offset: "18.0457937%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCADD",
    stopOpacity: 0.60296066,
    offset: "94.6236262%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E4F1",
    stopOpacity: 0.570462189,
    offset: "96.2197128%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFF",
    stopOpacity: 0.542792149,
    offset: "97.7042068%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F5FA",
    stopOpacity: 0.518340048,
    offset: "99.0160589%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A5CD",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 12.5 804.667 12.5 804.667 1.832 0 1.832"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "105.613415%",
    y2: "97.0926418%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD8E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9992AF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,12.5 C0,17.194 15.958,21 38.5,21 L38.5,21 L766.166,21 C788.709,21 804.667,17.194 804.667,12.5 L804.667,12.5 L0,12.5 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "105.613415%",
    y2: "97.0926418%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9992AF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.334,0.5 C42.834,0.5 0,0.917 0,1.833 L0,1.833 L804.667,1.833 C804.667,0.917 761.833,0.5 748.333,0.5 L748.333,0.5 L56.334,0.5 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "106.573522%",
    y2: "50%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F4F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECBE4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D6D9A",
    stopOpacity: 0.35,
    offset: "7.26027517%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "15.847418%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E0F4",
    offset: "81.0487085%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE9F7",
    offset: "93.7818878%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M448.291,9.875 L356.373,9.875 C351.933,9.875 348.333,6.275 348.333,1.835 L348.333,1.833 L456.333,1.833 C456.333,6.274 452.733,9.875 448.291,9.875",
    id: "path-10"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "01_Homepage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-2",
    transform: "translate(0.000000, -467.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "macbook"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mockup",
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 466.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-6"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-3"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-2)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.25,
    fill: "#D1F9FF",
    style: {
      mixBlendMode: "color"
    },
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-8"
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.25,
    fill: "#D1F9FF",
    style: {
      mixBlendMode: "color"
    },
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-10"
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.25,
    fill: "#D1F9FF",
    style: {
      mixBlendMode: "color"
    },
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-12"
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    xlinkHref: "#path-10"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-9)",
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.25,
    fill: "#D1F9FF",
    style: {
      mixBlendMode: "color"
    },
    xlinkHref: "#path-10"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacbookBottom);
export default __webpack_public_path__ + "static/media/macbook-bottom.99ac9d2eafe666abdab1d7140451e60d.svg";
export { ForwardRef as ReactComponent };